export default __webpack_public_path__ + "static/media/image-about-hero.001e8103.jpg";